import React, { useEffect, useState } from "react";
import Layout from "../../../components/Layout";
import { Link } from "react-router-dom";
import { DownloadIcon, EditIcon } from "../../../assets/icons/Icons";
import Chip from "../../../components/Chip";
import { FilterContextProvider } from "../../../contexts/FilterContext";
import SearchFilter from "../../../components/filters/SearchFilter";
import EditCorporateCustomer from "../../../components/corporate-customer/Edit";
import CreateCorporateCustomer from "../../../components/corporate-customer/Create";
import MessagePopup from "../../../components/MessagePopup";
import DataTable from "../../../components/DataTable";
import useData from "../../../hooks/useData";
import useExportCSV from "../../../hooks/useExportCSV";
import FilterCorporateCustomers from "../../../api/corporate-customers/filterCorporateCustomers";
import ResetFilters from "../../../components/filters/ResetFilters";
import { useTranslation } from "react-i18next";
import SelectFilter from "../../../components/filters/SelectFilter";
import CustomTooltip from "../../../components/CustomTooltip";
import { useGlobalContext } from "../../../contexts/GlobalContext";
import { GetCountries } from "../../../api/offices/GetCountries";

const Index = () => {
  const { t } = useTranslation();

  const {
    data,
    errorMessage,
    loadingData,
    pageCount,
    newItemAdded,
    setNewItemAdded,
    itemUpdated,
    setItemUpdated,
    selectedItem,
    setSelectedItem,
    showEditItem,
    setShowEditItem,
    showCreateItem,
    setShowCreateItem,
  } = useData(FilterCorporateCustomers);

  const { setPageTitle, setBreadcrumbs } = useGlobalContext();
  const [countries, setcountries] = useState([]);

  useEffect(() => {
    setPageTitle(t("Settings"));
    setBreadcrumbs([t("Settings"), t("Corporate Customers")]);

    return () => {
      setPageTitle("");
      setBreadcrumbs([]);
    };
    // eslint-disable-next-line
  }, []);

  const { handleExportCSV } = useExportCSV(
    FilterCorporateCustomers,
    "corporate_customers"
  );

  const handleEditClick = (e, item) => {
    e.preventDefault();
    setSelectedItem(item);
    setShowEditItem(true);
  };

  const getcountires = async () => {
    const countries = await GetCountries();
    setcountries(countries);
  };

  useEffect(() => {
    getcountires();
  }, []);

  return (
    <Layout title={t("Settings")} breadcrumbs={t("Corporate Customers")}>
      {showCreateItem && (
        <CreateCorporateCustomer
          onCreate={() => {
            setShowCreateItem(false);
            setNewItemAdded(true);
          }}
          onClose={() => setShowCreateItem(false)}
        />
      )}
      {newItemAdded && (
        <MessagePopup
          title={t("Corporate Customer Added!")}
          message={t("The corporate customer has been successfully created!")}
          onClose={() => setNewItemAdded(false)}
        />
      )}
      {showEditItem && (
        <EditCorporateCustomer
          corporateCustomer={selectedItem}
          onClose={() => setShowEditItem(false)}
          onUpdate={() => {
            setShowEditItem(false);
            setItemUpdated(true);
          }}
        />
      )}
      {itemUpdated && (
        <MessagePopup
          title={t("Corporate Customer Updated!")}
          message={t("The corporate customer has been successfully updated!")}
          onClose={() => setItemUpdated(false)}
        />
      )}

      <DataTable
        filtersTop={
          <>
            <FilterContextProvider name="s">
              <SearchFilter placeholderText={t("Search by name")} />
            </FilterContextProvider>
          </>
        }
        filtersBottom={
          <>
            <FilterContextProvider name="status">
              <SelectFilter
                options={[
                  {
                    value: "1",
                    label: t("Active"),
                  },
                  {
                    value: "0",
                    label: t("Disabled"),
                  },
                ]}
                placeholder={<div>{t("Status")}</div>}
              />
            </FilterContextProvider>
            <FilterContextProvider>
              <ResetFilters />
            </FilterContextProvider>
          </>
        }
        buttons={
          <>
            <button
              onClick={handleExportCSV}
              className="btn btn-secondary btn-medium"
              disabled={loadingData || !data.data || data.data.length === 0}
            >
              <DownloadIcon />
              {t("Export CSV")}
            </button>
            <button
              onClick={() => setShowCreateItem(true)}
              className="btn btn-primary btn-medium"
            >
              {t("Add")}
            </button>
          </>
        }
        columns={[
          { header: t("Corporate Name"), accessor: "corporate_name" },
          { header: t("Status"), accessor: "status" },
          { header: t("Address"), accessor: "address1" },
          { header: t("Address2"), accessor: "address2" },
          { header: t("City"), accessor: "city" },
          { header: t("State"), accessor: "state" },
          { header: t("Postal Code"), accessor: "postal_code" },
          { header: t("Country"), accessor: "country_code" },
          { header: t("Action"), accessor: "actions" },
        ]}
        rows={data.data || []}
        pageCount={pageCount}
        loadingData={loadingData}
        error={errorMessage}
        actions={(item) => (
          <>
            <Link to="#" onClick={(e) => handleEditClick(e, item)}>
              <CustomTooltip icon={<EditIcon />} message={t("Edit")} />
            </Link>
          </>
        )}
        customOutputs={(columnName, value) => {
          switch (columnName) {
            case "country_code":
              return (
                countries?.find((country) => country.value === value)?.label ||
                t(value)
              );
            case "status":
              return (
                <Chip
                  state={value === 0 ? "inactive" : "active"}
                  label={value === 0 ? "Disabled" : "Active"}
                  showAsTooltop
                />
              );
            default:
              return value;
          }
        }}
      />
    </Layout>
  );
};

export default Index;
